import { request } from './client';

/**
 * 更新个人信息
 */
export const updateProfile = async (payload) => {
  return request('/user/profile', {
    method: 'PUT',
    body: payload,
  });
};

/**
 * 修改密码
 * @param {Object} payload - { oldPassword, newPassword }
 */
export const changePassword = async (payload) => {
  return request('/user/password', {
    method: 'PUT',
    body: payload,  // ✅ 修复：改为body传参（安全）
  });
};

/**
 * 上传头像
 * @param {Object} payload - { avatarUrl }
 */
export const uploadAvatar = async (payload) => {
  return request('/user/avatar', {
    method: 'POST',
    body: payload,  // ✅ 修复：改为body传参
  });
};

